export default __webpack_public_path__ + "static/DocentToad_Logo_white-ring-c4f95545497d250dcdda7cb91a794903.svg";